<template>
  <div class="player-container">
    <QuickVideoPlayer :video="video" />
  </div>
</template>

<script>
import QuickVideoPlayer from './QuickVideoPlayer.vue';

export default {
  name: 'QuickVideoPlay',
  components: {
    QuickVideoPlayer
  },
  data(){
    return {
      video:null
    }
  },
  props: {
    
  },
  methods:{
    
  },
  created(){

    const qrjson=JSON.parse(this.$common.qr.qrjson);
    
    const index=this.$route.query.index;

    this.video=qrjson.videos[index]; 

  },
  mounted(){

    this.$common.video_play_page=true;

    this.$root.$forceUpdate();

  },
  unmounted(){

    this.$common.video_play_page=false;

    this.$root.$forceUpdate();

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .player-container{
    padding:30px 10px;
  }
</style>